export default __webpack_public_path__ + "static/media/doubleCard.1ac82a43.svg";